import utils from 'utils'
class creditLineCtrl {
    constructor($rootScope, $scope, logger, httpRequest, $state, $stateParams, $uibModal) {
        $('body').addClass('leftnav-close')
        $scope.dictData = {}
        $scope.treeConfig = {
            isCheckall: true,
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
            },
        }
        const typecodeArr = ['platform_type']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        $scope.search = {
            orgArr: [],
        }
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                orgIdList: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],
            },
        }
        // NOTE: 重置
        $scope.reset = () => {
            $scope.queryParam.param = {
                orgIdList: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],
            }
            getOrgList()
        }
        $scope.orgList = []
        function getOrgList() {
            httpRequest.get_getUserOrgList().then((res) => {
                $scope.orgList = res.data.value
                $scope.selectedOrgs = $scope.orgList.filter((ele) => {
                    if (ele.orgId === $scope.userInfo.org.orgId) {
                        ele.checked = true
                    }
                })
            })
        }
        $scope.tabChange = function tabChange(v) {
            $scope.active = v
        }
        // 根据数据 判断页面tab页签展示
        $scope.active = 1
        // NOTE: 搜索
        $scope.searchAuth = () => {
            getAuthList()
        }
        // NOTE: page修改
        $scope.pageChanged = (pageNum) => {
            getAuthList()
        }
        const getAuthList = () => {
            $scope.queryParam.param.orgIdList = $scope.queryParam.param.selectedOrgs.map((ele) => {
                return ele.orgId
            })
            httpRequest.post_findListByChannelPage($scope.queryParam).then((res) => {
                if (res && res.data && res.data.success) {
                    $scope.authList = res.data.value && res.data.value.list
                    $scope.total = res.data.value && res.data.value.total
                }
            })
        }
        getOrgList()
        getAuthList()
        // 乐企平台传值 creditCode    电子税局传值 authorizeId
        $scope.modelCheck = function modelCheck(item) {
            $uibModal
                .open({
                    templateUrl: 'goToQueryModel.html',
                    openedClass: 'mod-modal mod-modal-md',
                    animation: true,
                    controller: [
                        '$scope',
                        'items1',
                        '$uibModalInstance',
                        'logger',
                        'httpRequest',
                        function ($scope, items1, $uibModalInstance, logger, httpRequest) {
                            $scope.dataInfo = {
                                authorizeId: ''
                            }
                            let manageType = items1.manageType=='7'?'7':'6,8'
                            httpRequest.get_getOvatTax4AuthDrawer(items1.orgId,manageType).then((res) => {
                                if (res && res.data && res.data.success) {
                                    $scope.invoicerList = res.data.value
                                }
                            })
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                            $scope.ok = function ok() {
                                if(!$scope.dataInfo.authorizeId) return logger.logError("开票员不能为空！")
                                let drawerId = $scope.invoicerList.filter((item) => {return item.authorizeId === $scope.dataInfo.authorizeId})
                                httpRequest.post_ovatTax4Drawerget({ drawerId: drawerId[0].drawerId }).then((res) => {
                                    //loginStatus 1登录成功  0未登录
                                    if(res.data.value.loginStatus == '0'){
                                        return logger.logError("所选开票员未登录，请先到实名认证界面进行登录操作。")
                                    }else {
                                        let data = {}
                                        if(items1.manageType == '6'){ //电子税局
                                            data = {
                                                authorizeId:$scope.dataInfo.authorizeId
                                            }
                                        }
                                        if(items1.manageType == '7'){ //乐企平台
                                            data = {
                                                creditCode:items1.creditCode,
                                            }
                                        }
                                        if(items1.manageType == '8'){ //全票通
                                            data = {
                                                authorizeId:$scope.dataInfo.authorizeId,
                                            }
                                        }
                                        httpRequest.post_refreshAuthAmount(data).then((res) => {
                                            if (res && res.data && res.data.success) {
                                                $uibModalInstance.dismiss()
                                                getAuthList()
                                            }
                                        })
                                    }
                                })
                            }
                        },
                    ],
                    resolve: {
                        items1() {
                            return item
                        },
                    },
                })
        }
        //刷新机构
        $scope.refreshOrg = function () {
            $uibModal
                .open({
                    templateUrl: 'refreshOrgModel.html',
                    openedClass: 'mod-modal mod-modal-lg',
                    animation: true,
                    controller: [
                        '$scope',
                        'items1',
                        '$uibModalInstance',
                        'logger',
                        'httpRequest',
                        function ($scope, items1, $uibModalInstance, logger, httpRequest) {
                            $scope.currentUserInfo = JSON.parse(localStorage.user_info).user;
                            $scope.orgList = items1.orgList
                            angular.forEach($scope.orgList, function (item, index) {
                                item.checked = false
                                // 默认勾选当前机构
                                if (item.orgId === $scope.currentUserInfo.currentOrgId) {
                                  item.checked = true
                                  // 默认显示当前机构
                                  $scope.selectedOrgList = [item]
                                }
                              })
                            $scope.manageTypesList = items1.manageTypesList
                            $scope.dataInfo = {
                                orgId: $scope.currentUserInfo.currentOrgId,
                                manageType: '8',
                                authorizeId: ''
                            }
                            //机构树的check配置信息
                            $scope.config = {
                                check: {
                                    enable: true, //显示不显示复选框
                                    chkboxType: { Y: '', N: '' },
                                    chkStyle: 'radio',
                                    radioType: 'all',
                                },
                            }
                            ukeyIdChange()
                            $scope.ukeyChange = function () {
                                ukeyIdChange()
                            }
                                // 所选择的机构名称
                            $scope.handleOrgChange = function (orgData) {
                                $scope.dataInfo.orgId = orgData[0].orgId
                                ukeyIdChange()
                            }
                            function ukeyIdChange() {
                                let manageTypes = $scope.dataInfo.manageType=='7'?'7':'6,8'
                                httpRequest.get_getOvatTax4AuthDrawer($scope.dataInfo.orgId, manageTypes).then((res) => {
                                    if (res && res.data && res.data.success) {
                                        $scope.invoicerList = res.data.value
                                    }
                                })
                            }
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                            $scope.ok = function ok() {
                                console.log($scope.dataInfo)
                                if (!$scope.dataInfo.authorizeId) return logger.logError("请选择开票点")
                                let drawerId = $scope.invoicerList.filter((item) => { return item.authorizeId === $scope.dataInfo.authorizeId })
                                let creditCode = $scope.orgList.filter((item) => { return item.orgId === $scope.dataInfo.orgId })
                                httpRequest.post_ovatTax4Drawerget({ drawerId: drawerId[0].drawerId }).then((res) => {
                                    //loginStatus 1登录成功  0未登录
                                    if (res.data.value.loginStatus == '0') {
                                        return logger.logError("所选开票员未登录，请先到实名认证界面进行登录操作。")
                                    } else {
                                        let data = {}
                                        if ($scope.dataInfo.manageType == '6') { //电子税局
                                            data = {
                                                authorizeId: $scope.dataInfo.authorizeId
                                            }
                                        }
                                        if ($scope.dataInfo.manageType == '7') { //乐企平台
                                            data = {
                                                creditCode: creditCode[0].saleCreditCode,
                                            }
                                        }
                                        if ($scope.dataInfo.manageType == '8') { //全票通
                                            data = {
                                                authorizeId: $scope.dataInfo.authorizeId,
                                            }
                                        }
                                        httpRequest.post_refreshAuthAmount(data).then((res) => {
                                            if (res && res.data && res.data.success) {
                                                $uibModalInstance.dismiss()
                                                logger.logSuccess('刷新成功')
                                                getAuthList()
                                            }
                                        })
                                    }
                                })
                            }
                        },
                    ],
                    resolve: {
                        items1() {
                            return {
                                orgList: $scope.orgList,
                                manageTypesList: $scope.dictData.platform_type,
                            }
                        },
                    },
                })
        }
    }
}
creditLineCtrl.$inject = ['$rootScope', '$scope', 'logger', 'httpRequest', '$state', '$stateParams', '$uibModal']
export default creditLineCtrl



// WEBPACK FOOTER //
// ./src/app/main/creditLine/creditLineCtrl.js